import { z } from "@/zod";
import i18n from "@/i18n";

const schema = z
  .object({
    password: z
      .string()
      .min(1, i18n.t("resetPassword.errorMessages.missingPassword")),
    passwordConfirmation: z
      .string()
      .min(
        1,
        i18n.t("resetPassword.errorMessages.missingPasswordConfirmation"),
      ),
    code: z.string().min(1, i18n.t("resetPassword.errorMessages.missingCode")),
  })
  .refine((data) => data.password === data.passwordConfirmation, {
    message: i18n.t("resetPassword.errorMessages.passwordsDoNotMatch"),
    path: ["passwordConfirmation"],
  });

export default schema;
